import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_container/${agro_exporter_id}/fetch_container/${container_id}`
    );
  },
  fetchProducersOrganizations(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/manage_container/${agro_exporter_id}/fetch_producers_organizations/` +
        agro_exporter_process_id
    );
  },
  update(agro_exporter_id, container_id, container_params) {
    return RequesterV1.post(
      `agro_exporter/finances/container_outcomes/manage_container/${agro_exporter_id}/update/${container_id}`,
      { container: container_params }
    );
  },
};
